import React, { useEffect, useState } from "react";
import { Button, ConfigProvider, Form, message, Modal, Select } from "antd";
import locale from "antd/es/locale/es_ES";
import { GetAllAules } from "../../../../dao/GetAllAules";
import JutgeColors from "../../../../styles/JutgeColors";
import { PostJutgeCazaCopy } from "../../../../dao/jutge/PostJutgeCazaCopy";

interface Props {
    id_caza: number;
    visible: boolean;
    onClose: (updated: boolean) => void;
}

const CopyPildoraModal: React.FC<Props> = ({ id_caza, visible, onClose }) => {
    const [aules, setAules] = useState<any[]>([]);
    const [selectedAules, setSelectedAules] = useState<number[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible) loadAules();
    }, [visible]);

    async function loadAules() {
        try {
            const data = await GetAllAules("");
            setAules(data || []);
        } catch (err) {
            console.error(err);
            message.error("Error carregant les aules");
        }
    }

    const handleCancel = () => {
        setSelectedAules([]);
        onClose(false);
    };

    async function handleGuardar() {
        if (!selectedAules.length) {
            message.warning("Selecciona almenys una aula");
            return;
        }

        try {
            setLoading(true);
            await PostJutgeCazaCopy(id_caza + "", selectedAules);
            message.success("Píldora duplicada correctament!");
            onClose(true);
        } catch (err) {
            console.error(err);
            message.error("Error en duplicar la píldora");
        } finally {
            setLoading(false);
        }
    }

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Duplicar Píldora formativa"
                open={visible}
                onCancel={handleCancel}
                footer={null}
                width={500}
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Selecciona les aules destinataries"
                        tooltip="Tria una o més aules on vols duplicar aquesta píldora formativa"
                    >
                        <Select
                            mode="multiple"
                            placeholder="Selecciona les aules"
                            value={selectedAules}
                            onChange={(values) => setSelectedAules(values)}
                            style={{ width: "100%" }}
                        >
                            {aules.map((aula: any) => (
                                <Select.Option key={aula.id} value={aula.id}>
                                    {aula.nom}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <div style={{ textAlign: "right", marginTop: 24 }}>
                        <Button onClick={handleCancel} style={{ marginRight: 8 }}>
                            Cancel·lar
                        </Button>
                        <Button
                            type="primary"
                            style={{ backgroundColor: JutgeColors.colors.color4 }}
                            loading={loading}
                            onClick={handleGuardar}
                        >
                            Duplicar
                        </Button>
                    </div>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default CopyPildoraModal;
